import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const HIDE_ON = ['/select-categories', '/sign-up'];

const hideZendesk = () => {
  const zE = window.zE;
  if (!zE) return;
  zE('webWidget', 'close');
  zE('webWidget', 'hide');
};

const showZendesk = () => {
  const zE = window.zE;
  if (!zE) return;
  zE('webWidget', 'show');
};

export function useZendeskHideOnCertainPages() {
  const { pathname } = useLocation();

  useEffect(() => {
    const shouldHide = HIDE_ON.some((p) => pathname.startsWith(p));
    if (shouldHide) hideZendesk();
    else showZendesk();
  }, [pathname]);
}
